import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const FlowSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default FlowSVG;
